import { useQuery } from '@tanstack/react-query'
import { analyticsAPI } from '../api/analytics'

export type StatsPeriod = 'week' | 'month' | 'year'

export const useAdminStats = (period: StatsPeriod = 'month') =>
  useQuery({
    queryKey: ['admin-stats', period],
    queryFn: () => analyticsAPI.getGlobalStats(period),
    staleTime: 5 * 60 * 1000,
  })

export const useAdminTimeline = (period: 'week' | 'month' = 'week') =>
  useQuery({
    queryKey: ['admin-timeline', period],
    queryFn: () => analyticsAPI.getTimeline(period),
    staleTime: 2 * 60 * 1000,
  })
